import React, { ReactNode } from 'react'
import { FixedObject } from 'gatsby-image'
import { H } from 'react-document-section'
import { t } from '@lingui/macro'

import { i18n } from 'utils/i18n'
import { Container, Row, Col } from 'components/grid'
import ExpandableText from 'components/expandableText'

import HeaderDecorator from './HeaderDecorator'
import { root, title, description } from './index.module.scss'

interface Props {
  imgMobile: FixedObject
  imgDesktop: FixedObject
  children: ReactNode
  className?: string
}

const SeoIndexPageHeader = ({
  className = '',
  imgMobile,
  imgDesktop,
  children,
}: Props) => (
  <div className={`${root} ${className}`}>
    {imgMobile || imgDesktop ? (
      <HeaderDecorator imgMobile={imgMobile} imgDesktop={imgDesktop} />
    ) : null}
    <Container>
      <Row>
        <Col xs={12}>
          <H className={title} />
        </Col>
        <Col xs={12} sm={10} md={8} lg={6} xl={5}>
          <ExpandableText
            className={description}
            buttonText={{
              readMore: i18n._(t`Read more`),
              readLess: i18n._(t`Read less`),
            }}
          >
            {children}
          </ExpandableText>
        </Col>
      </Row>
    </Container>
  </div>
)

export default SeoIndexPageHeader
